import { render, staticRenderFns } from "./OmniSearch.vue?vue&type=template&id=634ea71e&"
import script from "./OmniSearch.vue?vue&type=script&lang=ts&"
export * from "./OmniSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports